import { object, string } from 'yup';

export const TIME_OPTIONS = [
  {
    value: '5',
    label: '5 dias',
  },
  {
    value: '2',
    label: '2 dias',
  },
  {
    value: '1',
    label: '1 dia',
  },
  {
    value: '1h',
    label: '1h',
  },
  {
    value: '30m',
    label: '30m',
  },
  {
    value: '15m',
    label: '15m',
  },
  {
    value: '5m',
    label: '5m',
  },
];

export const initialValues = {
  address: '',
  alias: '',
  time: '1h',
  amount: '',
};

export const validationSchema = object().shape({
  address: string().required('Campo Requerido'),
  alias: string().notRequired(),
  time: string().notRequired(),
  amount: string().notRequired(),
});
